import { render, staticRenderFns } from "./marcketing.vue?vue&type=template&id=b6ea1f86&scoped=true&"
import script from "./marcketing.vue?vue&type=script&lang=js&"
export * from "./marcketing.vue?vue&type=script&lang=js&"
import style0 from "./marcketing.vue?vue&type=style&index=0&id=b6ea1f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ea1f86",
  null
  
)

export default component.exports